
    import "src/app/AppSeller/SettingsPage/Profile/index.module.scss?farm_css_modules";
    
    export default {"buttonsForResponsivness": `buttonsForResponsivness-82cd34f1`,"header": `header-82cd34f1`,"profilePage": `profilePage-82cd34f1`,"title": `title-82cd34f1`,"titleId": `titleId-82cd34f1`}
    